module.exports = __webpack_public_path__ + "static/finding-my-leadership-voice-hero-1920x1080-97034e9314c47123107be94c56bd8484.jpg";